exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-task-table_buttons .a-button-primary:first-child{margin-right:15px}.c-task-table_activity-templates>.a-button-tertiary{min-width:unset;padding:unset;display:block;height:unset}", ""]);

// exports
